<template>
    <CModal
      :color="color"
      :show.sync="showModal"
      size="lg"
      class="basic-modal-color"
    >   
    <template #header>
      <CRow style="width: 100%; height: 35px;">
        <CCol md="9">
          <h5 class="modal-title">{{title}}</h5>
        </CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>      
        <CCol md="12">
          <form id="tables_form" method="POST" enctype="multipart/form-data">
            <CInput
                label="Imagen:"
                :isValid="checkIfValid('image')"
                :lazy="false"
                placeholder=""
                type="file"
                :value.sync="$v.form.image.$model"
                name="image"
                id="image"
                accept=".jpg,.jpeg,.png"
                invalidFeedback="Este campo es requerido."
                autocomplete="image"
              />
          </form>
        </CCol>
        <CCol md="12">
          <CRow class="mb-3">
            <CCol md="4" sm="12" class="d-flex align-items-center mb-2 mb-md-0">
              <CButton class="crema" size="sm" :disabled="isSearching" @click="selectAll()">Seleccionar Todos</CButton>
            </CCol>
            <CCol md="8" sm="12" class="d-flex align-items-center">
              <input
                v-model="searchTerm"
                type="text"
                class="form-control"
                placeholder="Buscar invitado..."
              />
            </CCol>
          </CRow>
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="filteredGuests"
            :fields="fields"
            :dark="dark"
          >         
            <template #position="{item}">
              <td class="text-center w80">
                <input
                  type="checkbox"
                  v-model="idsGuests"
                  @change="checkGuests(item)"
                  :value="item.id"
                  :id="'check-'+item.id"
                  :disabled="isInCooldown(item)"
                >
              </td>
            </template>
            <template #name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.name}}</b></td></template>
            <template #last_name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
            <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
            <template #phone="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                {{item.phone}}
                <div v-if="Number(item.is_in_cooldown) === 1 && item.whatsapp_cooldown_until" style="font-size: 11px;">
                  <CBadge color="warning">Cooldown</CBadge>
                  hasta {{ item.whatsapp_cooldown_until | datetime }}
                </div>
              </td>
            </template>
            <template #email="{item}">
              <td class="text-center w200" style="font-size: 12px;">
                <template v-if="item.email != ''">
                  {{item.email}}
                </template>
                <template v-else>
                  -
                </template>                  
              </td>
            </template>
            <template #tickets="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.tickets}}</td></template>
            <template #table="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                <template v-if="item.table != ''">
                  {{item.table}}
                </template>
                <template v-else>
                  -
                </template>                
              </td>
            </template>
            <template #confirm_date="{item}">
              <td class="text-center w100">
                <template v-if="item.is_confirm != ''">
                  {{item.confirm_date | date}}                  
                </template>                
              </td>
            </template>       
            <template #confirm_method="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.confirm_method == 'admin'">
                  Administrador
                </template>
                <template v-else-if="item.confirm_method == 'whats'">
                  Whatsapp
                </template>
                <template v-else-if="item.confirm_method == 'email'">
                  Correo Electronico
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </template>                 
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">                
              </td>
            </template>
          </CDataTable>        
          <CAlert color="primary">Si el invitado no tiene asignada una mesa, solo se enviará un mensaje con la información del evento.</CAlert>
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendMessage" :color="color">Enviar Mensaje</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendTableMessageModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'phone', label: 'Whatsapp',_style:"font-size: 12px;"},
          {key: 'email', label: 'Email',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"}
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Enviar Mesas",
      color: "info",
      submitted: false,      
      guests: [],      
      idsGuests:[],
      statusCheckAll: false,
      event: false,
      message: "",
      searchTerm: "",
      form: this.getEmptyForm(),
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    isInCooldown (guest) {
      if (!guest) return false;
      return Number(guest.is_in_cooldown) === 1 && !!guest.whatsapp_cooldown_until;
    },
    selectedGuestsWithoutCooldown () {
      const selected = this.idsGuests || [];
      return selected.filter(id => {
        const guest = this.guests.find(item => item.id === id);
        return guest && !this.isInCooldown(guest);
      });
    },
    async showSendModal (event_id, event) {
      this.event = event;
      this.message = "";
      this.searchTerm = "";

      this.form = this.getEmptyForm();

      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Enviar Mesas';
        this.isEdit = false;
        this.submitted = false;

        this.guests = [];
        this.idsGuests = [];
        this.statusCheckAll = false;

        let filters = {
          event_id: event_id,
          is_confirm: 1
        };
      
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.guests = response.data;

          this.guests.forEach(function callback(guest) {
              guest.checkbox = false;
          });
        }
      this.loaded();

    },
    async sendMessage () {
      this.loading();

      let guests = this.selectedGuestsWithoutCooldown();
      this.idsGuests = guests;

      if(guests.length > 0){
        this.$v.$touch();

        if (this.isValid) {
          this.submitted = true;        
          let form = document.getElementById("tables_form");
          let formData = new FormData(form);

          formData.append("guests", guests);

          let response = await ws.sendTableMessage(formData);

          if(response.type == "success"){
            this.showToast("success", response.message || "El mensaje con la asignación de mesas para los invitados han sido enviado correctamente.");
            
            this.closeModal();
          }
          else{
            this.showToast("error", response.message);
          }
        }
        else{
          this.showToast("error", "Debes seleccionar la imagen para el mensaje de asignación de mesas para enviar a los invitados.");
        }
      }
      else{
        this.showToast("error", "Debes seleccionar al menos un invitado para enviar la asignación de mesas.");
      }

      this.loaded();          
    },
    checkGuests: function(element){
      if (!this.idsGuests.includes(element.id)) {
        this.statusCheckAll = false;
      }
    },
    selectAll () {
      if (this.isSearching) {
        return;
      }

      if(!this.idsGuests.length > 0){
        this.statusCheckAll = false;  
      }
      this.idsGuests = [];            
      this.statusCheckAll = !this.statusCheckAll
      if(this.statusCheckAll){
        this.guests.forEach(element => {
          if (this.isInCooldown(element)) {
            return;
          }
          this.idsGuests.push(element.id) ;
        });
      }
    },
    getEmptyForm () {
      return {
          image: "",
      }
    },
    closeModal () {
      this.showModal = false;
      this.searchTerm = "";

      this.guests.forEach(function callback(guest) {
          guest.checkbox = false;
      });

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset();
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid)
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
    isSearching () { return this.searchTerm.trim().length > 0 },
    filteredGuests () {
      if (!this.isSearching) {
        return this.guests;
      }

      const term = this.searchTerm.trim().toLowerCase();

      return this.guests.filter(guest => {
        const searchableValues = [
          guest.name,
          guest.last_name,
          guest.nickname,
          guest.phone,
          guest.email,
          guest.table,
          guest.tickets,
        ]
          .map(value => (value === null || value === undefined ? '' : String(value).toLowerCase()))
          .join(' ');

        return searchableValues.includes(term);
      });
    },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      image: {
        required,
      },
      event_id:{

      },
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
.crema{
  background-color: #F4F0E5;
  color: black;
}
</style>